'use client';
import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';

const AllowanceReasonCodeSelect = ({ name, label, control, error = false, helperText = '', readOnly = false }) => {
  const { common } = useTranslatedMessages();
  const allowanceReasonCodeSelect = common.allowance_reason_code_select ?? {};
  const resolvedLabel = label ?? allowanceReasonCodeSelect.label;
  const discountReasonCodesList = useSelector((state) => state.codeLists.discountReasonCodesList) ?? [];

  const getSelectedOption = (code) => {
    return discountReasonCodesList.find((item) => item.code === code) || null;
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          id="allowance-reason-select"
          options={discountReasonCodesList}
          readOnly={readOnly}
          getOptionLabel={(option) => `${option.code} - ${option.reason}`}
          isOptionEqualToValue={(option, value) => option.code === value?.code}
          value={getSelectedOption(field.value)}
          onChange={(_, selected) => {
            field.onChange(selected?.code ?? '');
          }}
          renderInput={(params) => (
            <TextField {...params} label={resolvedLabel} error={error} helperText={helperText} />
          )}
        />
      )}
    />
  );
};

export default AllowanceReasonCodeSelect;
